class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
  
      if(this.hasAttribute("data-gifts")) {
        const key = this.dataset.key;
        const data = {
          updates: {
            [key]: 0
          },
          attributes: {
            gifts_removed: this.dataset.gifts
          }
        };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok.');
        })
        .then(data => {
          console.log('Item removed and attributes updated', data);
        })
        .catch(error => {
          console.error('There was a problem updating the cart:', error);
        });
        
        // fetch('/cart/update.js', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     'X-Requested-With': 'XMLHttpRequest'
        //   },
        //   body: JSON.stringify(data)
        // })
        // .then(response => {
        //   if (response.ok) {
        //     return response.json();
        //   }
        //   throw new Error('Network response was not ok.');
        // })
        // .then(data => {
        //   cartItems.updateQuantity(this.dataset.index, 0);
        // })
        // .catch(error => {
        //   console.error('There was a problem updating cart attributes:', error);
        // });
      
      } else if (window.cartRemoveConfirm) {
        window.cartRemoveConfirm.open(this, cartItems);
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

function addToXbWishlist(productId, variantId) {
  const config = window.xb_wishlist || {};
  const payload = {
    action: 'add',
    customerId: config.customerId || '',
    productId: String(productId),
    shop: config.myShopify || '',
    variantId: String(variantId),
    sessionId: '',
  };

  return fetch('/tools/xb-wishlist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (!response.ok) throw new Error('xb-wishlist add request failed');
      return fetch('/tools/xb-wishlist/update-count', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: String(productId), action: 'increment' }),
      });
    })
    .catch((error) => {
      console.error('There was a problem adding the item to the wishlist:', error);
    });
}

class CartRemoveConfirm {
  constructor(modal) {
    // Moved out of <cart-drawer>, which is `display: none` while closed and would hide this along with it.
    document.body.appendChild(modal);

    this.modal = modal;
    this.pending = null;
    this.opener = null;
    this.imageEl = modal.querySelector('.cart-remove-confirm-modal__image');
    this.closeButton = modal.querySelector('.cart-remove-confirm-modal__close');
    this.wishlistButton = modal.querySelector('.cart-remove-confirm-modal__wishlist');
    this.removeButton = modal.querySelector('.cart-remove-confirm-modal__remove');

    this.closeButton.addEventListener('click', () => this.close());
    this.wishlistButton.addEventListener('click', () => this.confirmWishlist());
    this.removeButton.addEventListener('click', () => this.confirmRemove());
    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) this.close();
    });
    this.modal.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });
  }

  open(button, cartItems) {
    this.pending = {
      index: button.dataset.index,
      productId: button.dataset.productId,
      variantId: button.dataset.variantId,
      cartItems,
    };
    this.opener = button;

    if (button.dataset.image) {
      this.imageEl.src = button.dataset.image;
      this.imageEl.alt = button.dataset.title || '';
      this.imageEl.hidden = false;
    } else {
      this.imageEl.hidden = true;
    }

    this.modal.setAttribute('open', '');
    this.closeButton.focus();
  }

  close() {
    this.pending = null;
    this.modal.removeAttribute('open');
    if (this.opener) this.opener.focus();
    this.opener = null;
  }

  confirmRemove() {
    if (!this.pending) return;
    const { index, cartItems } = this.pending;
    this.close();
    cartItems.updateQuantity(index, 0);
  }

  confirmWishlist() {
    if (!this.pending) return;
    const { index, productId, variantId, cartItems } = this.pending;
    this.close();

    addToXbWishlist(productId, variantId).finally(() => {
      cartItems.updateQuantity(index, 0);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('CartRemoveConfirmModal');
  if (modal) {
    window.cartRemoveConfirm = new CartRemoveConfirm(modal);
  }
});

class GiftResetButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      
      fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              "gifts_removed": ""
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Cart updated:', data);
          location.reload();
        })
        .catch(error => {
          console.error('Error updating cart:', error);
      });
    });
  }
}

customElements.define('gift-reset-button', GiftResetButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.closest(".cart-main")?.classList.add("style--sectionLoading");
    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartData = undefined;
  cartUpdateUnsubscriber = undefined;
  cartPageUpdateUnsubscriber = undefined;

  connectedCallback() {
    const cartDataElement = this.querySelector("#catt-json");
    this.cartData = cartDataElement ? JSON.parse(cartDataElement.textContent) : null;
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      document.dispatchEvent(new CustomEvent("upsell:update", { detail: event.cartData }));

      if (event.source === 'cart-items') {
        return;
      }
      
      this.onCartUpdate();
    });

// pradinė būsena – pagal cartData iš #catt-json
if (this.cartData) {
  this.initGiftProducts(this.cartData);
}
      
    this.initGiftProducts(this.cartData);

    this.cartPageUpdateUnsubscriber = subscribe("cartPage-update", (event) => {
      this.onCartPageUpdate(event);
    });
  }

initGiftProducts(cartData) {
  if (!cartData || !cartData.items) {
    return;
  }
  const cartVariantIds = cartData.items.map(item => Number(item.variant_id));
  const parentGiftPairs = [];
  const addGiftPromises = [];

  const giftsRemoved = (cartData.attributes?.gifts_removed || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .map(Number);

  // --- Handle "dovana" logic (product-specific gifts) ---
  for (const item of cartData.items) {
    const giftMetafield = item.metafields?.find(mf => mf.type === 'dovana');
    if (!giftMetafield) continue;

    const parentId = Number(item.variant_id);
    const itemKey = item.key;

    const skus = giftMetafield.skus?.split(',').map(s => s.trim()).filter(Boolean);
    const productSku = item.sku;
    if (Array.isArray(skus) && skus.length && !skus.includes(productSku)) continue;

    const giftVariantIds = (giftMetafield.discount_amount || '')
      .split(',')
      .map(s => Number(s.trim()))
      .filter(Boolean);

    if (giftVariantIds.length === 0) continue;

    if (giftVariantIds.length === 1) {
      // Single gift: add directly
      const giftVariantId = giftVariantIds[0];
      if (giftsRemoved.includes(giftVariantId)) continue;

      const alreadyAdded = cartData.items.some(
        i => Number(i.variant_id) === giftVariantId && i.properties?._gift_parent == parentId
      );

      if (!alreadyAdded) {
        addGiftPromises.push(
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: giftVariantId, quantity: 1, properties: { _gift_parent: parentId } }]
            })
          }).then(res => {
            if (!res.ok) throw { status: res.status, itemKey };
            return res;
          })
        );
      }
    } else {
      // Multiple gift choices: selection handled on product page, nothing to do in cart
    }
  }

/*for (const item of cartData.items) {
  const giftMetafield = item.metafields?.find(mf => mf.type === 'dovana');
  if (!giftMetafield) continue;

  const parentId = Number(item.variant_id);
  const giftVariantId = Number(giftMetafield.discount_amount);
  const itemKey = item.key;

  const skus = giftMetafield.skus?.split(',').map(s => s.trim()).filter(Boolean);
  const productSku = item.sku;

  // jeigu SKU nėra sąraše – skip
  if (Array.isArray(skus) && skus.length && !skus.includes(productSku)) continue;

  // jeigu vartotojas šitą dovaną buvo atsisakęs – skip
  if (giftsRemoved.includes(giftVariantId)) continue;

  // kiek dovanų šitam parent variantui jau yra krepšelyje
  const existingGiftQty = cartData.items
    .filter(i => Number(i.variant_id) === giftVariantId && i.properties?._gift_parent == parentId)
    .reduce((sum, i) => sum + Number(i.quantity || 0), 0);

  // kiek šito varianto prekių yra krepšelyje
  const parentQty = Number(item.quantity || 0);

  // kiek dovanų DAR reikia pridėti
  const qtyToAdd = parentQty - existingGiftQty;

  if (qtyToAdd > 0) {
    addGiftPromises.push(
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: giftVariantId,
            quantity: qtyToAdd,
            properties: { _gift_parent: parentId }
          }]
        })
      }).then(res => {
        if (!res.ok) {
          throw { status: res.status, itemKey };
        }
        return res;
      })
    );
  }
}*/


  // --- Handle cart threshold (upsell) gifts ---
  for (const upsellItem of cartData.upsell_items || []) {
    const meta = upsellItem.metafields?.find(mf => mf.type === 'cart');
    if (!meta) continue;

    const requiredAmount = Number(meta.amount_required) * 100;
    const giftVariantId = Number(upsellItem.variant_id);

    if (cartData.total_price > requiredAmount &&
        !cartVariantIds.includes(giftVariantId) &&
        !giftsRemoved.includes(giftVariantId)) {

      addGiftPromises.push(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: giftVariantId,
            quantity: 1,
            properties: { _gift_type: 'cart_threshold' }
          }]
        })
      }));
    }
  }

  // --- Handle "dovana_suma" logic ---
  const sumaGiftGroups = {};
  for (const item of cartData.items) {
    const meta = item.metafields?.find(mf => mf.type === 'dovana_suma');
    if (!meta) continue;

    const skus = meta.skus?.split(',').map(s => s.trim()).filter(Boolean);
    const productSku = item.sku;

    if (Array.isArray(skus) && skus.length && !skus.includes(productSku)) continue;

    const giftVariantId = Number(meta.discount_amount);
    const amountRequired = Number(meta.amount_required) * 100;

    if (!sumaGiftGroups[giftVariantId]) {
      sumaGiftGroups[giftVariantId] = { amountRequired, total: 0 };
    }

    sumaGiftGroups[giftVariantId].total += Number(item.final_line_price);
  }

  for (const [giftVariantIdStr, group] of Object.entries(sumaGiftGroups)) {
    const giftVariantId = Number(giftVariantIdStr);

    if (group.total > group.amountRequired &&
        !cartVariantIds.includes(giftVariantId) &&
        !giftsRemoved.includes(giftVariantId)) {

      addGiftPromises.push(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: giftVariantId,
            quantity: 1,
            properties: { _gift_type: 'dovana_suma' }
          }]
        })
      }));
    }
  }

  console.log(addGiftPromises);

  // --- Final sync ---
  // if (addGiftPromises.length > 0) {
  //   Promise.all(addGiftPromises)
  //     .then(() => {
  //       console.log('Gift(s) added successfully.');
  //       location.reload();
  //     })
  //     .catch(err => console.error('Gift add error:', err));
  // } else {
  //   this.closest(".cart-main").classList.remove("style--sectionLoading");
  // }
  
  Promise.allSettled(addGiftPromises)
  .then(results => {
    let anySuccess = false;

    results.forEach(result => {
      if (result.status === 'fulfilled') {
        anySuccess = true;
      } else if (result.status === 'rejected') {
        const { itemKey, status } = result.reason || {};
        if (itemKey) {
          const errorEl = document.querySelector(`[data-key="${itemKey}"] .discount-error`);
          if (errorEl) {
            errorEl.textContent = `Gift not available (error ${status || 'unknown'})`;
          }
        }
      }
    });

    if (anySuccess) {
      location.reload();
    } else {
      this.closest(".cart-main")?.classList.remove("style--sectionLoading");
    }
  })
  .catch(err => {
    console.error('Unexpected error in gift add process:', err);
    this.closest(".cart-main")?.classList.remove("style--sectionLoading");
  });
}


  checkGiftProduct(cartData) {
    const total = cartData.total_price / 100;
    const hasGift = cartData.items.some(item => item.variant_id === GIFT_VARIANT_ID);

    if (total >= 100 && !hasGift && !sessionStorage.getItem(GIFT_SESSION_KEY)) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        sessionStorage.setItem(GIFT_SESSION_KEY, 'true');
        // After adding, trigger a cart update to refresh UI
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-autoadder', cartData: cart });
          });
      })
      .catch(console.error);
    }

    // Optional: Remove gift if total drops below 100
    else if (total < 100 && hasGift) {
      const giftItem = cartData.items.find(item => item.variant_id === GIFT_VARIANT_ID);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 })
      })
      .then(() => {
        sessionStorage.removeItem(GIFT_SESSION_KEY);
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-autoremover', cartData: cart });
          });
      })
      .catch(console.error);
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }

    if (this.cartPageUpdateUnsubscriber) {
      this.cartPageUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    const key = event.target.dataset.key;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId,
        key
      );
    }
  }

  onChange(event) {
    if(event.target.name.indexOf("cart_upsell") > -1) {
      return;
    }
    this.validateQuantity(event);
  }

  updateCartSections() {
    const sectionIds = [
      "cart-icon-bubble",
      "cart-live-region-text",
      document.getElementById("main-cart-items")?.dataset.id
    ].filter(Boolean);

    fetch(`${routes.cart_url}?sections=${sectionIds.join(',')}`)
      .then(response => response.json())
      .then(htmlSections => {
        sectionIds.forEach((sectionId) => {
          const element = document.getElementById("shopify-section-" + sectionId);
          if (element && htmlSections[sectionId]) {
            element.innerHTML = htmlSections[sectionId];
          }
        });

        
        this.closest(".cart-main")?.classList.remove("style--sectionLoading");
      })
      .catch(err => console.error('Error updating cart sections:', err));
  }
  
  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }  
  
  onCartPageUpdate(event) {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        this.getSectionsToRender().forEach((section) => {
          let parsed = this.getSectionInnerHTML(
            event.cartData.sections[section.section],
            section.selector
          );
          
          if(section.id === "main-cart-items") {
            if(parsed.indexOf("cart-items") === -1 && document.querySelector(".cart-container")) {
              document.querySelector(".cart-container").classList.add("is-empty");
            }
          }
          
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = parsed;
          document.querySelector(".cart-main").classList.remove("style--sectionLoading");
        });

        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents-items',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, key, callback) {
    this.enableLoading(line);

    console.log('updateQuantity', line, quantity, name, variantId, key);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        // callback();
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);


        this.getSectionsToRender().forEach((section) => {
          let parsed = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          
          if(section.id === "main-cart-items" && parsed.length < 100 && document.querySelector(".cart-container")) {
            document.querySelector(".cart-container").classList.add("is-empty");
          }
          
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = parsed;
        });

         if (typeof this.initGiftProducts === 'function') {
        this.initGiftProducts(parsedState);
      }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
